import script from "./BundleDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./BundleDetails.vue?vue&type=script&setup=true&lang=ts"

import "./BundleDetails.vue?vue&type=style&index=0&id=692b5eb6&scoped=true&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-692b5eb6"]])

export default __exports__